import '../../../styles/index.css'
import './Preço.css';
import { formataPreço } from '../../../utils/preços';

function Preço({ preço, preçoParcelado }) {

  return (
    <section>
      {
        preçoParcelado ? (
        <>
          <h5 className='preço'>{`R$ ${formataPreço(preço.replace('.', ','))}`}</h5>
          <p className='b3 preçoParcelado'>{`ou 10x de R$ ${(parseFloat(preçoParcelado) / 10).toFixed(2).replace('.', ',')}`}</p>
        </>
        ) : (<h5 className='preço'>{`R$ ${formataPreço(preço.replace('.', ','))}`}</h5>)
      }
    </section>
  );
}

export default Preço;
